import Vue from 'vue';
import axios from 'axios';
import Qs from 'qs';
import VueAxios from 'vue-axios';
import Router from '../router/index';
import { Message, Loading } from 'element-ui';
import { baseUrl } from '@/http/baseUrl';

Vue.use(VueAxios, axios);
axios.defaults.baseURL = baseUrl;
axios.defaults.withCredentials = false;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
axios.defaults.headers['accessToken'] = (localStorage.getItem('token')) || '';
axios.defaults.timeout = 30000;
axios.defaults.transformRequest = function (data, headers) {
  if (headers['Content-Type'] === 'multipart/form-data') {
    return data;
  } else {
    return Qs.stringify(data);
  }
};
// 请求响应计数器
let requestNum = 0;
let responseNum = 0;
let loadingInstance;
Vue.nextTick(() => { // 解决Loading非全局单例的问题
  loadingInstance = Loading.service({
    target: document.getElementById('frameContent')
  });
  setTimeout(() => {
    loadingInstance.visible = false;
  }, 100);
});
// 请求拦截器
axios.interceptors.request.use(function (config) {
  requestNum++;
  // loadingInstance.visible = true;
  return config;
}, function (error) {
  console.log('请求出错了！');
  return Promise.reject(error);
});
// // 响应拦截器
axios.interceptors.response.use(function (response) {
  responseNum++;
  if (responseNum === requestNum) {
    Vue.nextTick(() => {
      loadingInstance.visible = false;
    });
  };
  // eslint-disable-next-line
  if (response.data.code == -100) { // 401重定向去登录认证
    Message.error({
      message: '请登录！'
    });
    window.location.href = `${baseUrl}visitor-manage/casLogin`;
  };
  // eslint-disable-next-line
  if (response.data.code == 401 || response.data.code === 403) { // 401重定向去登录认证
    Message.error({
      message: '请登录！'
    });
    window.location.href = `${baseUrl}visitor-manage/casLogin`;
  };
  return response;
}, function (error) {
  // Router.push({name: 'login'});
  responseNum++;
  if (responseNum === requestNum) {
    Vue.nextTick(() => {
      loadingInstance.visible = false;
    });
  };
  // eslint-disable-next-line
  if (error.response.status == '401' || error.response.status == '403') {
    Message.error({
      message: '登录过期请重新登录！'
    });
    setTimeout(() => {
      localStorage.removeItem('realName');
      window.location.href = `${baseUrl}visitor-manage/casLogin`;
    }, 2000);
  };
  if (!error.response) {
    Router.push({name: 'login'});
    Message.error({
      message: '网络异常！'
    });
  };
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/http/http.js